import { defineStore } from 'pinia'
import type { ManagerBenefitFilter } from '@/models/api/manager-benefit-get-list-request'

export const useCheckBoxTypeStore = defineStore('check-box-type', () => {
  const _checkBoxFormData = ref<ManagerBenefitFilter | null>({
    type: [],
    tag: []
  })

  /** checkBox FormData */
  const checkBoxFormData = computed(() => {
    return _checkBoxFormData.value
  })

  /** 設定 checkBox FormData */
  const setCheckBoxFormData = (data: ManagerBenefitFilter | null) => {
    _checkBoxFormData.value = data
  }

  /** 清空 checkBox FormData */
  const clearCheckBoxFormData = () => {
    _checkBoxFormData.value = null
  }

  return { checkBoxFormData, setCheckBoxFormData, clearCheckBoxFormData }
})
